import { render, staticRenderFns } from "./DraggableDialog.vue?vue&type=template&id=cc976542"
import script from "./DraggableDialog.vue?vue&type=script&lang=js"
export * from "./DraggableDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports